export const EXTERNAL_MENTION_TYPE = 'da-draft-plugin-external-mention';
export const EXTERNAL_MENTION_ENTITY_TYPE = 'mention';
